import React from 'react'
import FlexView from 'react-flexview/lib'
import Dropzone from 'react-dropzone'
import './ImageDropzone.scss'
import DoneIcon from '@material-ui/icons/Done'
import { BrowserView, MobileView } from 'react-device-detect'
import { Button, Grid } from '@material-ui/core'
import { OptionalTag } from '../OptionalTag'
import HelpIcon from '@material-ui/icons/Help'
import LightTooltip from '../LightTooltip'
import { ReactComponent as Camera } from '../../../assets/eqtypes/camera.svg'

export const ImageDropzone = (props) => {
  const {
    multiple = false,
    accept = 'image/*',
    hasImage = false,
    description = 'Drag an image of your drone here',
    mobileDescription = 'Upload drone image',
    buttonText = 'Upload Image',
    isImageMandatory = false,
    showImageRequired = false,
  } = props

  const imageUploaded = hasImage

  return (
    <Dropzone
      accept={accept}
      multiple={multiple}
      disabled={imageUploaded}
      onDrop={props.onDrop}>
      {({ getRootProps, getInputProps }) => (
        <FlexView hAlignContent={'center'} {...getRootProps()}>
          <input {...getInputProps()} />
          {imageUploaded ? (
            <FlexView
              className="margin-top-basic margin-bottom-small"
              hAlignContent={'center'}>
              <DoneIcon
                fontSize="small"
                className="green margin-bottom-2"
                size={18}
              />
              <div className="text-small green">
                Your image was uploaded successfully
              </div>
              <div
                onClick={props.changeImage}
                className="text-small margin-left-6 skyblue clickable">
                Change
              </div>
            </FlexView>
          ) : (
            <React.Fragment>
              <BrowserView>
                <div className="dropzone margin-top-small">
                  <Grid container spacing={4}>
                    <Grid item xs={3}>
                      <LightTooltip title="Providing your drone image will allow us to speed up the process in case of a claim">
                        <HelpIcon
                          fontSize="small"
                          className="lightgrayblue margin-left-6"
                        />
                      </LightTooltip>
                    </Grid>
                    <Grid item xs={6}>
                      <FlexView column hAlignContent={'center'}>
                        <div
                          className="text-small grey"
                          style={{
                            textAlign: 'center',
                          }}>
                          {description} or
                        </div>
                        <Button
                          variant="contained"
                          className="desktop_upload_button">
                          {buttonText}
                        </Button>
                        {showImageRequired && (
                          <div className="margin-top-small red">
                            Image is required
                          </div>
                        )}
                      </FlexView>
                    </Grid>
                    <Grid item xs={3}>
                      {!isImageMandatory && <OptionalTag />}
                    </Grid>
                  </Grid>
                </div>
              </BrowserView>
              <MobileView style={{ width: '100%' }}>
                <FlexView
                  vAlignContent={'center'}
                  className="margin-top-basic space-between">
                  <Button variant="contained" className="mobile_upload_button">
                    <FlexView vAlignContent={'center'} hAlignContent={'center'}>
                      <Camera
                        className="margin-right-6 gray medium-icon"
                        size={22}
                      />
                      <div>{mobileDescription}</div>
                    </FlexView>
                  </Button>
                  <div className="margin-top-6">
                    {!isImageMandatory && <OptionalTag />}
                  </div>
                </FlexView>
                {showImageRequired && (
                  <div className="margin-top-small red">Image is required</div>
                )}
              </MobileView>
            </React.Fragment>
          )}
        </FlexView>
      )}
    </Dropzone>
  )
}
